import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import {
  FlashMessage,
  Heading,
  InputFileUploads,
  SheetLayoutContent,
  SheetLayoutContentWrapper,
  SheetLayoutHeader,
} from '../../../brenger-shared-ui';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { translate } from '../../../utils/localization';
import FooterLayout from '../containers/FooterLayout';
import { actions, getPickupSituation } from '../ducks';
import { proceed } from '../proceed';

export const SubStepInvoice: React.FC<RouteComponentProps> = ({ location }) => {
  const situation = useTypedSelector(getPickupSituation);
  const dispatch = useDispatch();
  const invoices = useTypedSelector(state => state.generalTransport.choices?.invoices);
  const error = useTypedSelector(state => state.generalTransport.error);

  React.useEffect(() => {
    dispatch(actions.setProgress(7));
  }, [location.pathname]);

  return (
    <SheetLayoutContentWrapper>
      <SheetLayoutHeader>
        <Heading size={2}>
          <Translate id={`request_flow.pickup.${situation}.invoice_question`} />
        </Heading>
      </SheetLayoutHeader>
      <SheetLayoutContent>
        <h6 className={'mb-1'}>
          <Translate id={`request_flow.pickup.${situation}.invoice_label`} />
        </h6>
        <div className={'pb-[1em]'}>
          <Translate id={`request_flow.pickup.${situation}.invoice_description`} />
        </div>
        {!!invoices?.length && (
          <div className={'pb-[0.5em]'}>
            <Translate id={'request_flow.pickup.invoice.header'} />
          </div>
        )}
        <div className={'pb-[1em]'}>
          <InputFileUploads
            value={invoices}
            accept={'application/pdf'}
            onChange={iv => dispatch(actions.setChoice({ invoices: iv }))}
          />
        </div>
        {error && !invoices?.length && (
          <FlashMessage type={'error'} message={String(translate('upload_document.error.required'))} />
        )}
      </SheetLayoutContent>
      <FooterLayout customSubmitFunction={proceed} />
    </SheetLayoutContentWrapper>
  );
};
